module.exports = __webpack_public_path__ + "img/no-contributed.9e87b3f3.png";